import {
  Center,
  Flex,
  Icon,
  Tooltip,
  type TooltipProps,
} from '@chakra-ui/react';
import { KFormLabel } from '@/ui-library/components';
import { MarkdownSubtext } from '@/utils/MarkdownSubtext';
import { InfoCircle } from '@kula-ai/icons-core';

type FormCustomLabelItem = {
  label?: string;
  name?: string;
  subLabel?: string;
  labelStyles?: React.CSSProperties;
  subLabelStyles?: React.CSSProperties;
  type?: string;
  labelInfoText?: string;
  labelInfoIconColor?: string;
  labelInfoTextPlacement?: TooltipProps['placement'];
  showLabel?: boolean;
};

export const FormCustomLabel = ({
  item = {},
}: {
  item?: FormCustomLabelItem;
}) => {
  const {
    label,
    name,
    subLabel,
    labelStyles,
    subLabelStyles,
    type,
    labelInfoText,
    labelInfoIconColor,
    labelInfoTextPlacement,
    showLabel = true,
  } = item;

  if (['checkbox', 'switch'].includes(type || '')) return null;

  return (
    <>
      {label && showLabel && (
        <Flex alignItems="center">
          <KFormLabel
            htmlFor={String(name)}
            overflow="hidden"
            style={{ ...labelStyles }}
          >
            {label}
          </KFormLabel>

          {labelInfoText && (
            <Tooltip
              variant="default"
              label={labelInfoText}
              placement={labelInfoTextPlacement}
            >
              <Center pr="12px" pb="4px">
                <Icon
                  as={InfoCircle as React.ElementType}
                  {...(labelInfoIconColor && { color: labelInfoIconColor })}
                />
              </Center>
            </Tooltip>
          )}
        </Flex>
      )}

      {subLabel && (
        <KFormLabel
          htmlFor={name}
          style={{ ...subLabelStyles }}
          variant="subLabel"
          requiredIndicator={null}
        >
          <MarkdownSubtext
            markdown={subLabel}
            bodyColor="currentColor"
            bg="transparent"
            p={0}
            m={0}
          />
        </KFormLabel>
      )}
    </>
  );
};
